import { useMemo } from 'react';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SkippedAssetsAlert(props) {
  const {
    hideTitle
  } = props;
  const {
    skippedAssets,
    copyableAssets,
    totalAssetsCount
  } = useAssetCopierContext();
  const skippedCounts = useMemo(() => {
    const counts = {
      nonAutomatedEmails: 0,
      alreadyCopiedAssets: 0
    };
    skippedAssets.forEach(asset => {
      if (asset.skipReason === 'NOT_AUTOMATED_EMAIL') {
        counts.nonAutomatedEmails++;
      } else if (asset.skipReason === 'ALREADY_COPIED') {
        counts.alreadyCopiedAssets++;
      }
    });
    return counts;
  }, [skippedAssets]);
  if (skippedCounts.alreadyCopiedAssets === 0 && skippedCounts.nonAutomatedEmails === 0) {
    return null;
  }
  const titleKey = copyableAssets.length === 0 ? 'ui-multi-account-asset-copier.panel.skippedAssetsAlert.titleNone' : 'ui-multi-account-asset-copier.panel.skippedAssetsAlert.title';
  const showAlreadyCopiedAssets = skippedCounts.alreadyCopiedAssets > 0;
  const showNonAutomatedEmails = skippedCounts.nonAutomatedEmails > 0;
  const listStyled = showAlreadyCopiedAssets && showNonAutomatedEmails;
  return /*#__PURE__*/_jsx(Alert, {
    titleText: !hideTitle && /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleKey,
      options: {
        count: totalAssetsCount
      }
    }),
    marginBlockStart: "500",
    children: /*#__PURE__*/_jsxs(List, {
      styled: listStyled,
      paddingInlineStart: listStyled ? '500' : '0',
      children: [showAlreadyCopiedAssets && /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.skippedAssetsAlert.alreadyCopiedAssets",
          options: {
            count: skippedCounts.alreadyCopiedAssets
          }
        })
      }), showNonAutomatedEmails && /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-multi-account-asset-copier.panel.skippedAssetsAlert.nonAutomatedEmails",
          options: {
            count: skippedCounts.nonAutomatedEmails
          }
        })
      })]
    })
  });
}
export default SkippedAssetsAlert;